// generic-client
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useMe from 'utils/hooks/useMe/useMe';

const useUserLanguage = () => {
  const { i18n } = useTranslation();
  const { me } = useMe({ include: { preferences: true } });

  useEffect(() => {
    if (me?.preferences?.profile?.language && me.preferences.profile.language !== i18n.language) {
      i18n.changeLanguage(me.preferences.profile.language);
    }
  }, [me, i18n]);
};

export default useUserLanguage;
